import {
  Button,
  Dropdown,
  Form,
  Grid,
  Input,
  Popup,
  Text,
} from '@wework/dieter-ui'
import { withFloorMap } from '@wework/react-floormap'

import React from 'react'
import { Lock } from '../Icons'
import SATextHolder from '../EditPanel/SATextHolder'

function ProductType({
  space,
  floorMap,
  setRoomData,
  roomData,
  isChair = false,
}: any) {
  if (!space) {
    return <></>
  }
  if (!roomData) {
    return <></>
  }

  let options = []
  const labelKey = 'name'
  const valueKey = 'spaceType'
  const types = floorMap?.extensions.classification.getRoomTypes()

  options =
    types &&
    types.map(option => {
      return {
        key: option[valueKey],
        value: option[valueKey].toUpperCase(),
        text: option[labelKey],
      }
    })

  function capitalizeFirstLetter(string) {
    let productType = ''
    if (string != '') {
      productType = string.charAt(0).toUpperCase() + string.slice(1)
    }
    return productType
  }

  return (
    <>
      {space.inventoryData && space.inventoryData?.relationships?.length > 0 && (
        <Grid>
          <Grid.Row>
            <Grid.Column width={8}>
              <div>
                <SATextHolder
                  title="Inventory name"
                  text="What is the name of this inventory?"
                />
              </div>
            </Grid.Column>
            <Grid.Column width={8}>
              <Form.Field
                control={Input}
                outline
                label="Name"
                defaultValue={space.inventoryData?.relationships[0]?.name}
                value={space.inventoryData?.relationships[0]?.name}
                icon={
                  <div
                    style={{
                      position: 'absolute',
                      right: 5,
                      top: 10,
                      cursor: 'pointer',
                    }}
                  >
                    <Button
                      icon={<Lock />}
                      style={{ padding: 0, background: 'white' }}
                    />
                  </div>
                }
              />
            </Grid.Column>
          </Grid.Row>
          {!isChair && (
            <Grid.Row>
              <Grid.Column width={8}>
                <div>
                  <SATextHolder
                    title="Inventory type"
                    text="What type of inventory is this?"
                  />
                </div>
              </Grid.Column>
              <Grid.Column width={8}>
                <Form.Field
                  control={Input}
                  outline
                  autoCapitalize="none"
                  label="Type"
                  value={
                    space.inventoryData?.relationships.length > 0
                      ? capitalizeFirstLetter(
                          space.inventoryData?.relationships[0]?.product_type
                            .toLowerCase()
                            .replace('_', ' ')
                        )
                      : ''
                  }
                  icon={
                    <div
                      style={{
                        position: 'absolute',
                        right: 5,
                        top: 10,
                        cursor: 'pointer',
                      }}
                    >
                      <Button
                        icon={<Lock />}
                        style={{ padding: 0, background: 'white' }}
                      />
                    </div>
                  }
                />
              </Grid.Column>
            </Grid.Row>
          )}
        </Grid>
      )}
    </>
  )
}
export default withFloorMap()(ProductType)
